import { render, staticRenderFns } from "./ks-news.vue?vue&type=template&id=47fcf25c"
var script = {}
import style0 from "./ks-news.vue?vue&type=style&index=0&id=47fcf25c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports